

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/5 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user shadow-md">
          <img
            src="../assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="../assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">{{getGreetingTime}} {{user_displayName}},</h1>
          <p
            class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
          >Our Smart Lights provide flexible, wireless and remote power management.</p>
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
        <statistics-card-trend
          icon="CrosshairIcon"
          :statistic="numberOfZones"
          statisticTitle="Zones Created"
          type="trendZone"
        ></statistics-card-trend>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
        <statistics-card-trend
          icon="MapPinIcon"
          :statistic="numberOfLocations"
          statisticTitle="Locations Setup "
          color="warning"
          type="trendLocation"
        ></statistics-card-trend>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
        <statistics-card-trend
          icon="CpuIcon"
          :statistic="numberOfModems"
          statisticTitle="Modems Installed"
          color="success"
          type="bar"
        ></statistics-card-trend>
      </div>
    </div>

    <div class="vx-row">
      <!-- CARD 4: SESSION -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse lg:flex-row">
            <!-- LEFT COL -->
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
              <div>
                <h2 class="mb-1 font-bold">2.7K</h2>
                <span class="font-medium">Avg Sessions</span>
                <p class="mt-2 text-xl font-medium">
                  <span class="text-success">+5.2%</span> vs last 7 days
                </p>
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-chevrons-right"
                icon-after
                class="shadow-md w-full lg:mt-0 mt-4"
              >View Details</vs-button>
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 mb-base">
              <change-time-duration-dropdown class="self-end" />
              <vue-apex-charts
                type="bar"
                height="200"
                :options="analyticsData.salesBar.chartOptions"
                :series="analyticsData.salesBar.series"
              />
            </div>
          </div>
          <vs-divider class="my-6"></vs-divider>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-3">
              <p>Goal: $100000</p>
              <vs-progress class="block mt-1" :percent="50" color="primary"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Users: 100K</p>
              <vs-progress class="block mt-1" :percent="60" color="warning"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Retention: 90%</p>
              <vs-progress class="block mt-1" :percent="70" color="danger"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Duration: 1yr</p>
              <vs-progress class="block mt-1" :percent="90" color="success"></vs-progress>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Product Orders">
          <!-- CARD ACTION -->
          <template slot="actions">
            <change-time-duration-dropdown />
          </template>

          <div slot="no-body">
            <vue-apex-charts
              type="radialBar"
              height="370"
              :options="analyticsData.productOrdersRadialBar.chartOptions"
              :series="analyticsData.productOrdersRadialBar.series"
            />
          </div>

          <ul>
            <li
              v-for="orderData in analyticsData.productOrdersRadialBar.analyticsData"
              :key="orderData.orderType"
              class="flex mb-3 justify-between"
            >
              <span class="flex items-center">
                <span
                  class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                  :class="`border-${orderData.color}`"
                ></span>
                <span class="font-semibold">{{ orderData.orderType }}</span>
              </span>
              <span>{{ orderData.counts }}</span>
            </li>
            <!-- <li><span class="inline-block h-2 w-2 rounded-full mr-2 bg-primary"></span>Finished - 23,043</li> -->
          </ul>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardTrend from "@/components/statistics-cards/StatictCardTrend.vue";
import analyticsData from "@/components/dimmingPolicy/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import moment from "moment-timezone";

export default {
  data() {
    return {
      analyticsData: analyticsData
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardTrend,
    ChangeTimeDurationDropdown
  },
  created() {},
  computed: {
    user_displayName() {
      if (this.$store.state.userInfo == null) {
        return "";
      } else {
        return this.$store.state.userInfo.userName;
      }
    },
    getGreetingTime() {
      var currentTime = moment();
      if (!currentTime || !currentTime.isValid()) {
        return "Hello";
      }

      const splitAfternoon = 12; // 24hr time to split the afternoon
      const splitEvening = 17; // 24hr time to split the evening
      const currentHour = parseFloat(currentTime.format("HH"));

      if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
        // Between 12 PM and 5PM
        return "Good Afternoon";
      } else if (currentHour >= splitEvening) {
        // Between 5PM and Midnight
        return "Good Evening";
      }
      // Between dawn and noon
      return "Good Morning";
    },
    numberOfZones() {
      var zones = this.$store.state.zones;
      return zones.length;
    },
    numberOfLocations() {
      var locations = this.$store.state.locations;
      return locations.length;
    },
    numberOfModems() {
      var modems = this.$store.state.modems;
      return modems.length;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
